import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=bb21f102&scoped=true"
import script from "./appointment.vue?vue&type=script&lang=ts"
export * from "./appointment.vue?vue&type=script&lang=ts"
import style0 from "./appointment.vue?vue&type=style&index=0&id=bb21f102&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb21f102",
  null
  
)

export default component.exports